export enum CurrentOrderHandlingEnum {
  CONSIDER_CURRENT = 'CONSIDER_CURRENT',
  IGNORE_CURRENT = 'IGNORE_CURRENT',
  IGNORE_IF_LINKED_TO_SUGGESTED = 'IGNORE_IF_LINKED_TO_SUGGESTED',
}
